import type {CountryModel, ReviewModel, UserModel} from '../models'
import {ensureBoolean, ensureString} from '../utils/parse.utils'

export function ensureExistsObject(object: any | null | undefined) {
  if (!object) throw new Error('object is not present')
}

export const mapRestCountryToAppCountry = (country: any): CountryModel => {
  return {
    id: country.id,
    isoCode: country.alpha2,
    title: country.name,
    phoneLength: parseInt(country.phone_length, 10),
    phoneMask: country.phone_mask,
    phonePrefix: country.prefix,
    value: country.name,
    key: country.id,
    has_adverts: country.has_adverts,
  }
}

export const mapRestCountriesToAppCountries = (
  fields: Array<any>,
): Array<CountryModel> => {
  return fields.map(mapRestCountryToAppCountry)
}

export const mapRestUsersToAppUsers = (users: any[]): UserModel[] => {
  return users.map(mapRestUserToAppUser)
}

export const mapRestUserToAppUser = (user: any): UserModel => {
  return {
    id: ensureString('user.id', user.id),
    name: ensureString('user.name', user.name),
    isOnline: ensureBoolean('user.isOnline', user.isOnline),
    isShop: ensureBoolean('user.isShop', user.is_shop),
    isSubscribed: ensureBoolean(
      'user.is_subscribed',
      user.is_subscribed,
      false,
    ),
    isBlocked: ensureBoolean('user.isBlocked', user.is_blocked),
    surname: user.surname ?? '',
    imageUrl: user.image?.url,
    rating: parseInt(user.rating_mark, 10),
    ratingCount: parseInt(user.rating_mark_cnt, 10),
    activeProductCount: parseInt(user.prods_active_cnt ?? '0', 10),
    soldProductCount: parseInt(user.prods_sold_cnt, 10),
    archiveProductCount: parseInt(user?.prods_arhive_cnt ?? '0', 10),
  }
}

export const mapRestReviewsToAppReviews = (
  reviews: Array<any>,
): Array<ReviewModel> => {
  return reviews.map(mapRestReviewToAppReview)
}

export const mapRestReviewToAppReview = (review: any): ReviewModel => {
  return {
    id: ensureString('review.id', review.id),
    adId: ensureString('review.hash_advert', review.hash_advert),
    adTitle: ensureString('review.advert_title', review.advert_title),
    adCreatedAt: parseInt(review.date_added, 10),
    userId: ensureString('review.id', review.id),
    userName: ensureString('review.name', review.name),
    userRating: parseInt(review.mark, 10),
    userImage: review.image.url,
    userRegistrationDate: parseInt(review.date_registered, 10),
    isUserOnline: ensureBoolean('review.isOnline', review.isOnline),
    comment: review.comment,
    commentOriginal: review.comment_original,
  }
}
